import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { Button } from "components/Button";
import {
  prepareUnsubscribe,
  strategyUnsubscribe,
} from "features/Strategy/service";
import { PrepareUnsubscribeStrategyModalContainer } from "./PrepareUnsubscribeStrategyModal.styles";
import { Loader } from "components/Loader";

const PrepareUnsubscribeStrategyModal = ({
  show,
  onHide,
  strategyId,
  handleUnsubscribed,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [unSubOptions, setUnSubOptions] = useState(null);

  useEffect(() => {
    if (show) fetchUnlicenseTechniques();
  }, [show]);

  const fetchUnlicenseTechniques = async () => {
    try {
      setIsLoading(true);
      if (!strategyId) {
        dispatch(
          toast({
            body: "Strategy ID not found",
          })
        );
      }
      const response = await prepareUnsubscribe(strategyId);
      setUnSubOptions(response);
    } catch (error) {
      setIsLoading(false);
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowUnsubModal = (isFlat) => {
    handleStop(isFlat);
  };

  const handleStop = async (isFlat) => {
    try {
      if (!strategyId) {
        dispatch(
          toast({
            body: "Strategy ID not found",
          })
        );
      }
      const data = {
        strategyId,
        isFlat,
      };
      await strategyUnsubscribe(data);
      dispatch(
        toast({
          delay: 4000,
          body: "Your strategy has been unsubscribed, Your subscription will not renew. No further trades will be automated by this strategy",
        })
      );
      onHide();
      handleUnsubscribed();
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };

  return (
    <>
      <PrepareUnsubscribeStrategyModalContainer
        heading=""
        show={show}
        onHide={onHide}
      >
        <h3>Unlicense Strategy</h3>
        <p>{unSubOptions?.message}</p>
        {isLoading && <Loader />}
        {!isLoading && (
          <div className="button-wrapper">
            {unSubOptions?.option1 != "Cancel" && (
              <Row>
                <Col>
                  <Button
                    onClick={() => handleShowUnsubModal(true)}
                    label={unSubOptions?.option1}
                    className="btn-yes"
                  />
                </Col>
                <Col>
                  <Button
                    onClick={() => handleShowUnsubModal(false)}
                    label={unSubOptions?.option2}
                    className="btn-yes"
                  />
                </Col>
              </Row>
            )}
            {unSubOptions?.option1 == "Cancel" && (
              <Row>
                <Col>
                  <Button
                    onClick={() => onHide()}
                    label={unSubOptions?.option1}
                    className="btn-no"
                  />
                </Col>
                <Col>
                  <Button
                    onClick={() => handleShowUnsubModal(false)}
                    label={unSubOptions?.option2}
                    className="btn-yes"
                  />
                </Col>
              </Row>
            )}
          </div>
        )}
      </PrepareUnsubscribeStrategyModalContainer>
    </>
  );
};

PrepareUnsubscribeStrategyModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  strategyId: PropTypes.string,
  handleUnsubscribed: PropTypes.func,
};

export { PrepareUnsubscribeStrategyModal };
